/* Hangs from the bottom of the bar across the full width, with the hard
 * shadow below it so it reads as a sheet lying over the page. */
.menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px;
  background: var(--surface);
  border-bottom: var(--outline);
  border-radius: 0 0 var(--radius-card) var(--radius-card);
  box-shadow: 0 6px 0 var(--ink);
}

@media (min-width: 720px) {
  .menu {
    display: none;
  }
}

.links {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: var(--outline);
}

.secondary {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0 16px;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
}

.link {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 0 16px;
  border: 2px solid transparent;
  border-radius: var(--radius-control);
  font-size: 20px;
  font-weight: 700;
  text-decoration: none;
}

.link[aria-current='page'] {
  background: var(--accent);
  color: var(--accent-ink);
  border-color: var(--ink);
}
